import { apiClient } from './apiClient';
import { IPropertySale } from 'types/PropertyTypes';

interface PaginatedResponse {
  data: IPropertySale[];
  total: number;
  per_page?: number;
  current_page?: number;
  last_page?: number;
  from?: number;
  to?: number;
  meta?: { total: number };
}

export interface PropertySaleHistoryParams {
  page?: number;
  per_page?: number | 'all';
  property_type?: string;
  search?: string;
  station?: string;
  district?: string;
  saleDateStart?: string;
  saleDateEnd?: string;
  contractedDateStart?: string;
  contractedDateEnd?: string;
  sort_field?: string;
  sort_order?: string;
  priceMin?: number;
  priceMax?: number;
}

/**
 * 物件一覧を取得（ページネーション付き）
 */
export async function getList(params: PropertySaleHistoryParams = {}): Promise<PaginatedResponse> {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, String(value));
    }
  });
  return apiClient.get<PaginatedResponse>(`/property-sale-histories?${searchParams.toString()}`);
}

/**
 * 重複なしの区名一覧を取得
 */
export async function getDistricts(): Promise<{ districts: string[] }> {
  return apiClient.get<{ districts: string[] }>('/property-sale-histories/districts');
}

/**
 * 物件番号で物件詳細を取得
 */
export async function getByPropertyNumber(propertyNumber: string): Promise<IPropertySale> {
  return apiClient.get<IPropertySale>(`/property-sale-histories/property-number/${propertyNumber}`);
}
